import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProviderWorkspaceComponent } from '@app/workspace/components/provider-workspace/provider-workspace.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule, Routes } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { ProviderBaaSignatureComponent } from '@app/workspace/components/provider-baa-signature/provider-baa-signature.component';
import { PlCommonModule } from '@app/common/common.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';

const ROUTES: Routes = [{ path: '', component: ProviderWorkspaceComponent }];

@NgModule({
  declarations: [ProviderWorkspaceComponent, ProviderBaaSignatureComponent],
  imports: [
    PlCommonModule,
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatSnackBarModule,
    RouterModule.forChild(ROUTES),
  ],
})
export class ProviderWorkspaceModule {}
